"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var LockInfoConverter_1 = require("./conversions/LockInfoConverter");

var LockInfoConverterImpl_1 = require("./conversions/LockInfoConverterImpl");

var WorkflowCaseInfoConverter_1 = require("./conversions/WorkflowCaseInfoConverter");

var WorkflowCaseInfoConverterImpl_1 = require("./conversions/WorkflowCaseInfoConverterImpl");
/**
 * Configures workflow administration app module
 */


var WorkflowAdministrationAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(WorkflowAdministrationAppModule, _AppModule_1$AppModul);

  function WorkflowAdministrationAppModule() {
    var _this;

    _classCallCheck(this, WorkflowAdministrationAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowAdministrationAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'workflowAdministrationAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WorkflowAdministrationAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(WorkflowCaseInfoConverter_1.WorkflowCaseInfoConverter).to(WorkflowCaseInfoConverterImpl_1.WorkflowCaseInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(LockInfoConverter_1.LockInfoConverter).to(LockInfoConverterImpl_1.LockInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return WorkflowAdministrationAppModule;
}(AppModule_1.AppModule);

exports.WorkflowAdministrationAppModule = WorkflowAdministrationAppModule;